import React from 'react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-navy" data-id="element-25" data-mp="vsmi6b0ro86b">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:px-6 sm:py-8" data-id="element-26" data-mp="vu7d41qztt4p">
        <SectionHeading id="bonos" tone="dark" title="5 Bonos incluidos" subtitle={<>
              Y además recibes 5 recursos prácticos —{' '}
              <span className="text-gold" data-id="element-28" data-mp="ztpz70ujwa94">GRATIS con tu compra.</span>
            </>} data-id="element-27" data-mp="qsrxip7l4etp" />

        <ul className="mt-4 space-y-2" data-id="element-29" data-mp="1ei2ppiavd0w8">
          {bonuses.map((b, i) => <Reveal key={b.title} as="li" delay={i * 0.03} className="rounded-xl border border-dashed border-gold/60 bg-navy-soft p-3" data-id="element-30" data-mp="19k14ortvuri4" data-mpi={i}>
              <div className="flex items-start justify-between gap-3" data-id="element-31" data-mp="1jji6uz9xen9c">
                <p className="font-display text-[0.7rem] font-bold text-gold" data-id="element-32" data-mp="3pqlhyvxtwy58">
                  🎁 BONO {i + 1} — GRATIS
                </p>
                <p className="shrink-0 font-display text-[0.7rem] font-bold text-white/70" data-id="element-33" data-mp="3tsffwwgn3o1p">
                  Valor: <span className="text-white" data-id="element-34" data-mp="2k1997xzulkj">{b.value}</span>
                </p>
              </div>
              <h3 className="mt-1 font-display text-sm font-extrabold leading-tight text-white" data-id="element-35" data-mp="7ma5qea2s5re">
                {b.title}
              </h3>
              <p className="mt-1 text-[0.8rem] leading-snug text-white/75 sm:text-sm" data-id="element-36" data-mp="gldofh5byj5d">
                {b.desc}
              </p>
            </Reveal>)}
        </ul>

        <div className="mt-3 rounded-xl bg-gold px-4 py-2.5 text-center font-display text-navy" data-id="element-37" data-mp="le6t650strhg">
          <p className="text-sm font-bold" data-id="element-38" data-mp="qdb1ktfwfl6q">
            💰 Valor total de los 5 bonos:{' '}
            <span className="font-black line-through decoration-2" data-id="element-39" data-mp="vc4f2lv6rc6w">{BONUS_TOTAL}</span>
          </p>
          <p className="text-sm font-extrabold uppercase" data-id="element-40" data-mp="109mffnv50j3a">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}